<template>
    <Teleport to="body">
        <div class="modal" @click.self="closeModal" tabindex="-1" id="vacationmodal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="employee">{{ $trans.get('__JSON__.Requested vacation') }} {{ employee.forename
                        }} {{
                                employee.lastname }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-2">
                            <div v-if="errors" class="alert alert-danger" role="alert">
                                <div v-for="(v, k) of errors.errors" :key="k">
                                    <p v-for="error of v" :key="error">
                                        {{ $trans.get('__JSON__.' + error) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-6">
                                <div class="row mb-2">
                                    <div class="col-3">{{ $trans.get('__JSON__.Timespan') }}</div>
                                    <div class="col-9" v-if="selectedAbsence">{{
                                        to_luxon_ISOdate(selectedAbsence.start_at) }}
                                        - {{ to_luxon_ISOdate(selectedAbsence.end_at) }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">{{ $trans.get('__JSON__.Vacation days') }}</div>
                                    <div class="col-2" v-if="selectedAbsence">{{ selectedAbsence.workdays ?? '-'
                                    }}&nbsp;
                                        <span class="fw-bold"
                                            v-if="selectedAbsence && selectedAbsence.from_flextime == 1">{{
                                                $trans.get('__JSON__.From flextime') }}</span>
                                        <span class="fw-bold" v-if="selectedAbsence && selectedAbsence.unpaid == 1">{{
                                            $trans.get('__JSON__.Unpaid vacation') }}</span>
                                        <span class="fw-bold"
                                            v-if="selectedAbsence && selectedAbsence.special_leave == 1">{{
                                                $trans.get('__JSON__.Special leave') }}</span>
                                    </div>
                                    <div v-if="selectedAbsence && selectedAbsence.half_day && selectedAbsence.second_half"
                                        class="col-4 float-start"> {{ $trans.get('__JSON__.Second half of shift.') }}
                                    </div>
                                    <div v-if="selectedAbsence && selectedAbsence.half_day && !selectedAbsence.second_half"
                                        class="col-4 float-start"> {{ $trans.get('__JSON__.First half of shift.') }}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">{{ $trans.get('__JSON__.Comment') }}</div>
                                    <div class="col-9" v-if="selectedAbsence">{{ selectedAbsence.request_comment
                                        ?? '-'
                                    }}
                                    </div>
                                </div>
                                <div class="row mb-2" v-if="availableDaysReceived">
                                    <div class="col-9">
                                        {{ $trans.get('__JSON__.Possible days at this time of the year: ') }}
                                        &nbsp; {{ vacationEntitlement }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="team_id && overlappingTeamEvents" class="col-6 h-100">
                                <h4 class="text-danger">
                                    {{ $trans.get('__JSON__.Attention! Team events during selected timespan.')
                                    }}
                                </h4>
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{{ $trans.get('__JSON__.Team - Events') }}</th>
                                            <th>{{ $trans.get('__JSON__.start_at') }}</th>
                                            <th>{{ $trans.get('__JSON__.end_at') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="teamevent in overlappingTeamEvents">
                                            <td class="">{{ teamevent.name }}</td>
                                            <td class="">{{ to_luxon_ISOdate(teamevent.start_at) }}</td>
                                            <td class="">{{ to_luxon_ISOdate(teamevent.end_at) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="selectedAbsence.deniedRequests" class="col-6 h-100">
                                <h4 class="text-danger">
                                    {{ $trans.get('__JSON__.Attention! Vacation was rejected before.')
                                    }}
                                </h4>
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{{ $trans.get('__JSON__.when') }}</th>
                                            <th>{{ $trans.get('__JSON__.start_at') }}</th>
                                            <th>{{ $trans.get('__JSON__.end_at') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="deniedRequest in selectedAbsence.deniedRequests">
                                            <td class="">{{ to_luxon_ISOdate(deniedRequest.created_at) }}</td>
                                            <td class="">{{ to_luxon_ISOdate(deniedRequest.start_at) }}</td>
                                            <td class="">{{ to_luxon_ISOdate(deniedRequest.end_at) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3"></div>
                            <div class="col-9">{{ possibilityReport }}
                                <div v-if="!possibilityCheck">
                                    <ul>
                                        <li v-for="week in possibilityFaultyWeeks">
                                            <a :href="week.href">{{ week.linktext }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <table v-if="vacationdata" class="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>{{ $trans.get('__JSON__.Days') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{ $trans.get('__JSON__.Days left') }}
                                        </td>
                                        <td>{{ vacationdata.daysLeft }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ $trans.get('__JSON__.Days used') }}
                                        </td>
                                        <td>{{ vacationdata.daysUsed * -1 }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ $trans.get('__JSON__.Days granted') }}
                                        </td>
                                        <td>{{ vacationdata.daysGranted }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ $trans.get('__JSON__.Days requested') }}
                                        </td>
                                        <td>{{ vacationdata.daysRequested }}</td>
                                    </tr>
                                    <tr v-if="employee && employee.flextime">
                                        <td>
                                            {{ $trans.get('__JSON__.Flextime account') }}
                                        </td>
                                        <td>{{ flextimehours }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row mb-2">
                            <div class="col-2">
                                {{ $trans.get('__JSON__.Reject reason') }}
                            </div>
                            <div class="col-10">
                                <input id="reason" class="form-control" type="text" v-model="reason" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-3">
                                <div class="tooltipwrapper float-start" v-tooltip
                                    :title="$trans.get('__JSON__.Vacation can only be rejected with a reason')">
                                    <button :disabled="!reason || reason?.length == 0" class="btn btn-primary"
                                        @click="rejectVacation" id="rejectbutton">
                                        {{ $trans.get('__JSON__.Reject vacation') }}</button>
                                </div>
                            </div>
                            <div v-if="vacationdata" class="col-6">
                                <!-- Hinweis, Freigabe durch HR -->
                                <div v-if="selectedAbsence.needs_second_approval == 1 && !can('vacation-second-approve')"
                                    class="border border-danger bg-danger text-white rounded-3 pl-2 pt-1 pb-1">
                                    {{ $trans.get('__JSON__.Approval through HR') }}
                                </div>

                                <!-- Hinweis, Du kannst nicht ins Minus -->
                                <div v-if="vacationdata.daysLeft + vacationdata.daysRequested - selectedAbsence.workdays < 0 && !can('negative-vacation') && selectedAbsence.unpaid == 0 && selectedAbsence.special_leave == 0 && selectedAbsence.from_flextime == 0"
                                    class="border border-danger bg-danger text-white rounded-3 pl-2 pt-1 pb-1">
                                    {{ $trans.get('__JSON__.Not allowed to grant vacation which exceeds available days left') }}
                                </div>
                            </div>
                            <div v-if="vacationdata" class="col-3">
                                <!-- Urlaub Freigabe durch TeamLeiter Stufe 1-->
                                <button
                                    v-if="(selectedAbsence.needs_second_approval == 1 && !selectedAbsence.team_approved_at)"
                                    class="btn btn-primary float-end d-inline" @click="grantVacation">{{
                                        $trans.get('__JSON__.Team ok') }}</button>

                                <button
                                    v-if="canGrandVacation()"
                                    class="btn btn-primary float-end d-inline" @click="grantVacation">{{
                                        $trans.get('__JSON__.Grant vacation') }}</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { DateTime } from 'luxon';
import axios from "axios";

export default {
    setup() {

    },
    name: "EmployeeVacationModal",
    props: {
        employee: Object,
        selectedAbsence: Object,
        team_id: Number,
        filteredTeamEvents: Object,
    },
    emits: ['hideModal', 'reload','wasFirstStep2StepVacationGrant'],
    data() {
        return {
            errors: null,
            availableDaysReceived: false,
            possibilityReport: '',
            possibilityCheck: null, 
            possibilityFaultyWeeks: [],
            vacationdata: null,
            reason: null,
            flextimehours: null,
            vacationdata: null,
            vacationEntitlement: null,
        }
    },
    computed: {
        overlappingTeamEvents() {
            console.log('overlappingTeamEvents, team_id: ', this.team_id);
            if (!this.filteredTeamEvents || !this.selectedAbsence) {
                console.log('overlappingTeamEvents, no filteredTeamEvents or selectedAbsence', this.filteredTeamEvents, this.selectedAbsence);
                return null;
            }

            const startDayDate = new Date(this.selectedAbsence.start_at);
            const endDayDate = new Date(this.selectedAbsence.end_at);


            console.log('overlappingTeamEvents, startDayDate: ', startDayDate, ' endDayDate: ', endDayDate);

            if (this.team_id == 0) {
                const dayDateTeamEvents = this.filteredTeamEvents.filter(element =>
                    new Date(element.start_at).getTime() <= endDayDate.getTime()
                    && startDayDate.getTime() <= new Date(element.end_at).getTime()
                );

                if (dayDateTeamEvents.length > 0) {
                    console.log('overlappingTeamEvents, dayDateTeamEvents: ', dayDateTeamEvents);
                    return dayDateTeamEvents;
                }
            }
            const dayDateTeamEvents = this.filteredTeamEvents.filter(element => element.team_id == this.team_id
                && new Date(element.start_at).getTime() <= endDayDate.getTime()
                && startDayDate.getTime() <= new Date(element.end_at).getTime()
            );

            if (dayDateTeamEvents.length > 0) {
                console.log('overlappingTeamEvents, dayDateTeamEvents: ', dayDateTeamEvents);
                return dayDateTeamEvents;
            }
            return null;
        },
    },
    watch: {
        selectedAbsence: {
            handler: function (newValue, oldValue) {
                if (newValue != undefined || newValue != oldValue) {
                    this.getVacationData(this.selectedAbsence.employee_id, this.selectedAbsence.start_at);
                    this.getFlextimeHours(this.selectedAbsence.employee_id);
                    this.fetchPossibilityForVacation(this.selectedAbsence);
                }
            },
            deep: true,
        },
    },
    created() {
        this.getVacationData(this.selectedAbsence.employee_id, this.selectedAbsence.start_at);
        this.getFlextimeHours(this.selectedAbsence.employee_id);
        this.fetchPossibilityForVacation(this.selectedAbsence);
        
    },
    mounted() {
        // Alle Tooltips verstecken!
        $(".tooltip").css('display', 'none');
        $("#vacationmodal").modal("show");
        
    },
    methods: {
        canGrandVacation() {
            // Urlaub Freigabe durch HR Stufe 2
            if ((this.selectedAbsence.needs_second_approval == 1 && this.selectedAbsence.team_approved_at) && this.can('vacation-second-approve')) {
                return true;
            }

            // Normaler Urlaub oder vom Arbeitszeitkonto
            if ((this.vacationdata.daysLeft + this.vacationdata.daysRequested - this.selectedAbsence.workdays >= 0 || this.selectedAbsence.from_flextime == 1 || this.selectedAbsence.unpaid == 1) && this.selectedAbsence.needs_second_approval == 0) {
                return true;
            }

            // Normaler Urlaub aber nicht mehr genug Tage
            if (this.vacationdata.daysLeft + this.vacationdata.daysRequested - this.selectedAbsence.workdays < 0 && this.can('negative-vacation') && this.selectedAbsence.unpaid == 0 && this.selectedAbsence.special_leave == 0) {
                return true;
            }

            // Sonderurlaub
            if (this.selectedAbsence.special_leave == 1 && this.selectedAbsence.needs_second_approval == 0) {
                return true;
            }

            return false;
        },
        getVacationData(employee_id, start_at) {
            this.availableDaysReceived = false;
            let startAt = null;
            if (typeof start_at == 'object') {
                startAt = DateTime.fromJSDate(start_at).get('year');
            }
            if (typeof start_at == 'string') {
                startAt = DateTime.fromISO(start_at).get('year');
            }
            axios
                .get("/api/employees/" + employee_id + "/vacationdata", {
                    params: {
                        year: startAt
                    }
                })
                .then((resp) => {
                    this.vacationdata = resp.data;
                    this.getVacationEntitlement(employee_id, start_at);
                    this.fetchTeamEvents(start_at);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getFlextimeHours(employee_id) {
            axios
                .get("/api/flextimehours?employee_id=" + employee_id)
                .then((resp) => {
                    this.flextimehours = resp.data.flextime_hours;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });
        },
        getVacationEntitlement(employee_id, start_at) {
            axios
                .get("/api/employees/" + employee_id + "/projectedvacationentitelementforyear", {
                    params: {
                        start_at: start_at,
                    }
                })
                .then((resp) => {
                    if (resp.data) {
                        this.vacationEntitlement = resp.data.days;
                        this.availableDaysReceived = true;
                    }
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                });
        },
        fetchPossibilityForVacation(selectedAbsence) {
            axios
                .get("/api/projectemployeerequirements/checkWithoutEmployee?employee_id=" +
                    selectedAbsence.employee_id +
                    '&startDate=' +
                    this.formatDateForApiCall(selectedAbsence.start_at) +
                    '&endDate=' + this.formatDateForApiCall(selectedAbsence.end_at)
                ).then((resp) => {
                    if (resp.data[0].error !== false) {
                        this.possibilityFaultyWeeks = [];
                        for (const [week, year] of Object.entries(resp.data[0].additional_data.notPossibleWeeks)) {
                            var newLink = [];
                            newLink.href = '/shifts?team=' + this.employee.team_id + '&year=' + year + '&week=' + week + '&simulation=1';
                            newLink.linktext = 'Schichtplan für Woche ' + week;
                            this.possibilityFaultyWeeks.push(newLink);
                        }
                        this.possibilityReport = 'Achtung! Folgende Schichtpläne sind bei Genehmigung dieses Urlaubs nicht ausreichend besetzt!';
                    }
                }).catch((error) => {
                    console.log(error);
                });
        },
        fetchTeamEvents() {
            var dayStartFrom = this.to_luxon_ISOdate(this.selectedAbsence.start_at);
            axios
                .get("/api/teamevents", {
                    params: {
                        datefrom: dayStartFrom,
                    },
                })
                .then((resp) => {
                    this.teamevents = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        rejectVacation() {
            this.selectedAbsence.reject_reason = this.reason;
            axios
                .put("/api/absences/" + this.selectedAbsence.id + "/reject", {
                    reject_reason: this.reason
                })
                .then((resp) => {
                    this.closeModal('refresh');
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        grantVacation() {
            if (this.selectedAbsence.needs_second_approval == 1 && this.selectedAbsence.team_approved_at == null) {
                // Teamleiter muss erst genehmigen, dann HR
                this.selectedAbsence.team_approved_at = this.to_luxon_ISOdate(new Date());
            } else {
                if (this.selectedAbsence.needs_second_approval == 1 && !this.can('vacation-unpaid-approve')) {
                    alert('Zweite Freigabe muss durch Personalabteilung erfolgen!')
                } else {
                    // Teamleiter hat genemigt, nun HR
                    this.selectedAbsence.granted = true;
                }
            }

            axios
                .put("/api/absences/" + this.selectedAbsence.id,
                    {
                        ...this.selectedAbsence,
                        start_at: this.to_luxon_ISOdate(this.selectedAbsence.start_at),
                        end_at: this.to_luxon_ISOdate(this.selectedAbsence.end_at),
                    })
                .then((resp) => {
                    this.closeModal('refresh');
                    let respData = resp.data;
                    if(respData.granted == false && respData.team_approved_at != null && respData.needs_second_approval == 1)
                    {
                        this.$emit('needSecondApproval', true);
                        //console.log('emitted two phase vacation grant');
                    }
                    })
                .catch((error) => {
                    this.errors = error.response.data;
                    this.selectedAbsence.granted = false;
                    console.log(error);
                });
        },
        to_luxon_ISOdate(date) {
            let formattedDate = null;
            if (typeof date == 'object') {
                formattedDate = DateTime.fromJSDate(date).toISODate();
            }
            if (typeof date == 'string') {
                formattedDate = DateTime.fromISO(date).toISODate();
            }
            return formattedDate;
        },
        formatDateForApiCall(date) {
            let formattedDate = null;
            if (typeof date == 'object') {
                formattedDate = DateTime.fromJSDate(date).toFormat('dd.MM.yyyy');
            }
            if (typeof date == 'string') {
                formattedDate = DateTime.fromISO(date).toFormat('dd.MM.yyyy');
            }
            return formattedDate;
        },
        closeModal(refresh) {
            $("#vacationmodal").modal("hide");
            this.$emit('hideModal', true);
            if (refresh) {
                this.$emit('reload', true);
            }
        }
    }
}
</script>
